require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./posts-follow-your-customer.json") })
        }
      }, "path---posts-follow-your-customer");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---posts-follow-your-customer!./.cache/json/posts-follow-your-customer.json
// module id = 364
// module chunks = 231608221292675